import RequireData from "hooks/RequireData";
import React from "react";
import { Link } from "react-router-dom";
import invitedTeamsSelector from "selectors/invitedTeams";
import invitedTeamsStatusSelector from "selectors/invitedTeamsStatus";
import memberTeamsSelector from "selectors/memberTeams";
import memberTeamsStatusSelector from "selectors/memberTeamsStatus";
import HomeCard from "./HomeCard";

const TeamsCard: React.FC = () => {
    const [teams] = RequireData(
        memberTeamsSelector,
        memberTeamsStatusSelector,
        {
            type: "com.sage.actions.team.IFetchMemberTeams",
        } as sage.actions.team.IFetchMemberTeams
    );
    const [invitedTeams] = RequireData(
        invitedTeamsSelector,
        invitedTeamsStatusSelector,
        {
            type: "com.sage.actions.team.IFetchInvitedTeams",
        } as sage.actions.team.IFetchInvitedTeams
    );

    return (
        <HomeCard>
            <h5>Teams</h5>
            <p>
                {teams === null
                    ? "Loading"
                    : `You are apart of ${teams.length} teams.`}{" "}
                {invitedTeams &&
                    invitedTeams.length > 0 &&
                    `You have ${invitedTeams.length} pending team invites.`}
            </p>
            <Link to="/home/teams" className="card-link">
                Manage Teams
            </Link>
        </HomeCard>
    );
    ``;
};

export default TeamsCard;
